import React from "react";
import "./InterviewPrep.css";

const InterviewPrep = () => {
    const activities = [
        {
            number: "01",
            title: "JAM Sessions",
            description:
                "Improve your confidence, speaking ability and ability to express ideas clearly through regular JAM sessions.",
            icon: "🎤",
        },
        {
            number: "02",
            title: "Group Discussions",
            description:
                "Practice participating in group discussions, sharing ideas and communicating effectively with others.",
            icon: "👥",
        },
        {
            number: "03",
            title: "Mock Interviews",
            description:
                "Experience interview-style practice with technical and HR questions to become more confident before interviews.",
            icon: "💼",
        },
        {
            number: "04",
            title: "Communication Building",
            description:
                "Develop professional communication, presentation skills and workplace confidence.",
            icon: "🗣️",
        },
    ];

    const videos = [
        {
            number: "01",
            title: "JAM Session",
            video: "/videos/JAMSession1.mp4",
            description:
                "Students practicing speaking and presenting their ideas.",
        },
        {
            number: "02",
            title: "Group Discussion",
            video: "/videos/GroupDiscussion1.mp4",
            description:
                "Students developing teamwork and professional communication.",
        },
        {
            number: "03",
            title: "Mock Interview",
            video: "/videos/MockInterview1.mp4",
            description:
                "Students practicing technical and HR interview scenarios.",
        },
    ];

    return (
        <section className="interview-prep-section">

            {/* ================= HEADER ================= */}

            <div className="interview-prep-header">

                <span className="interview-prep-badge">
                    INTERVIEW &amp; COMMUNICATION
                </span>

                <h2>
                    Build Confidence for Your
                    <span> Career Journey</span>
                </h2>

                <p>
                    Technical knowledge is only one part of becoming job-ready.
                    At PRT Academy, students also practice communication,
                    interviews, presentations and group activities to prepare
                    for real workplace situations.
                </p>

            </div>


            {/* ================= ACTIVITIES ================= */}

            <div className="interview-activities">

                {activities.map((activity) => (
                    <article
                        className="interview-card"
                        key={activity.number}
                    >

                        <div className="interview-card-top">

                            <div className="interview-icon">
                                {activity.icon}
                            </div>

                            <span className="interview-number">
                                {activity.number}
                            </span>

                        </div>

                        <h3>
                            {activity.title}
                        </h3>

                        <p>
                            {activity.description}
                        </p>

                    </article>
                ))}

            </div>


            {/* ================= STUDENT VIDEOS ================= */}

            <div className="student-video-section">

                <div className="student-video-heading">

                    <span>
                        STUDENT ACTIVITIES
                    </span>

                    <h3>
                        Learn Through
                        <strong> Real Practice</strong>
                    </h3>

                    <p>
                        See how PRT Academy students participate in JAM
                        sessions, group discussions and interview preparation
                        activities.
                    </p>

                </div>


                <div className="student-video-grid">

                    {videos.map((item) => (

                        <article
                            className="student-video-card"
                            key={item.number}
                        >

                            <div className="student-video-wrapper">

                                {/* ================= SILENT VIDEO ================= */}

                                <video
                                    className="student-video"
                                    src={item.video}
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    preload="auto"
                                    disablePictureInPicture
                                    controlsList="nodownload nofullscreen noremoteplayback"
                                >
                                    Your browser does not support the video tag.
                                </video>

                                <span className="student-video-number">
                                    {item.number}
                                </span>

                            </div>


                            {/* ================= VIDEO CONTENT ================= */}

                            <div className="student-video-content">

                                <span className="student-video-label">
                                    PRT ACADEMY
                                </span>

                                <h4>
                                    {item.title}
                                </h4>

                                <p>
                                    {item.description}
                                </p>

                            </div>

                        </article>

                    ))}

                </div>

            </div>


            {/* ================= BOTTOM MESSAGE ================= */}

            <div className="interview-bottom">

                <div>

                    <span>
                        PRT ACADEMY
                    </span>

                    <h3>
                        Practice. Communicate.
                        <strong> Build Confidence.</strong>
                    </h3>

                </div>

                <p>
                    Regular practice helps students become more comfortable
                    communicating their knowledge in professional situations.
                </p>

            </div>

        </section>
    );
};

export default InterviewPrep;